<div class="Layout">
  <div class="header">
    <button
      class="header__hamburguer"
      [ngClass]="{ Mobile_Button_Active: isOpen }"
      (click)="isOpen = !isOpen"
    ></button>

    <div class="header__content">
      <img
        src="/assets/img/logo-compact.png"
        alt="Logo"
        (click)="routeTo('/home')"
        />
      </div>
    </div>

    <nav class="Sidebar" [ngClass]="{ Sidebar_Active: isOpen }">
      <div class="Menu_Container">
        <div class="Menu_Content">
          <div class="Logo_Header">
            <img src="{{ this.rota }}/Prancheta_3.png" alt="Logo" />
          </div>

          <ul class="List_Itens">
            @if (isRequestingProduto$ | async) {
              <sidebar-skeleton></sidebar-skeleton>
            } @else {
              <div>
                <sidebar-item
                  (p-click)="selectMenu(0); routeTo('/home')"
                  p-name="Início"
                  p-image="../../../../assets/icons/sidebar/home.png"
                  p-id="0"
                  >
                </sidebar-item>
                <div class="notificacoes-quantiadade">
                  @if (
                    (notificacoes$ | async) &&
                    (notificacoes$ | async).naolidas > 0
                    ) {
                    <div
                      class="notificacoes"
                      >
                      {{ (notificacoes$ | async).naolidas }}
                    </div>
                  }
                  <sidebar-item
                    [p-id]="-1"
                    (p-click)="selectMenu(-1); routeTo('/notificacoes')"
                    p-name="Notificações"
                    p-image="../../../../assets/icons/sidebar/notificacoes.png"
                    >
                  </sidebar-item>
                </div>
                @for (produto of produtos$ | async; track produto) {
                  <sidebar-item
                (p-click)="
                  selectMenu(produto.id);
                  produtoFacade.handleProdutoClick(produto)
                "
                    [p-name]="produto.nome"
                    [p-image]="getIcon(produto.icone)"
                    [p-id]="produto.id"
                    >
                  </sidebar-item>
                }
                <sidebar-item
                  (p-click)="logout()"
                  p-name="Sair"
                  p-image="../../../../assets/icons/sidebar/sair.png"
                  >
                </sidebar-item>
              </div>
            }

          </ul>
        </div>
      </div>

      <div class="Footer desktop-only" (click)="openLink()">
        <p class="Footer_Signature">Desenvolvido por</p>
        <div class="Logo_Footer">
          <img src="{{ this.rota }}/logo-footer.png" alt="Logo" />
        </div>
      </div>
    </nav>

    <ui-modal-banner></ui-modal-banner>
  </div>

  <router-outlet></router-outlet>

  <app-ligthboxes-default
    id="custom-message"
    class="hidden"
  ></app-ligthboxes-default>
